import { render, staticRenderFns } from "./ColorScheme.vue?vue&type=template&id=317816a6&scoped=true&"
import script from "./ColorScheme.vue?vue&type=script&lang=js&"
export * from "./ColorScheme.vue?vue&type=script&lang=js&"
import style0 from "./ColorScheme.vue?vue&type=style&index=0&id=317816a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317816a6",
  null
  
)

export default component.exports